import Enlang from './entries/en-US';
import Eslang from './entries/es_ES';

const AppLocale = {
  en: Enlang,
  es: Eslang,
};

export default AppLocale;
